import { useSelector } from 'react-redux'
import { getMessageRecipients } from 'shared/store/sendMessage/recipients/selectors'
import { getTerminology } from 'shared/store/terminology/selectors'
import { FilterTypeEnum } from '../models/Recipients'

const useGetTerminologyFilterTypes = () => {
  const { data: terminology, isLoading, error } = useSelector(getTerminology)
  const { meters, objects, openState } = useSelector(getMessageRecipients)

  if (isLoading || error) return []

  const list = [
    {
      id: FilterTypeEnum.Owners,
      displayText: terminology.Eiere,
    },
    {
      id: FilterTypeEnum.Tenants,
      displayText: terminology.Leietakere,
    },
    {
      id: FilterTypeEnum.Cohabitant,
      displayText: 'Medboere',
    },
    ...(openState !== 'Message'
      ? [
          {
            id: FilterTypeEnum.BoardMembers,
            displayText: 'Styre og komiteer',
          },
        ]
      : []),
    {
      id: FilterTypeEnum.Objects,
      displayText: 'Annet',
    },
    {
      id: FilterTypeEnum.Meters,
      displayText: 'Målere',
    },
    ...(openState !== 'Message'
      ? [
          {
            id: FilterTypeEnum.BoardContacts,
            displayText: 'Styrets kontakter',
          },
        ]
      : []),
    ...(openState !== 'Message'
      ? [
          {
            id: FilterTypeEnum.OtherContacts,
            displayText: 'Andre kontakter',
          },
        ]
      : []),
  ]

  return list.filter((item) => {
    // Filter out objects and meters if there are no objects or meters
    if (item.id === FilterTypeEnum.Objects && !objects.length) return false
    if (item.id === FilterTypeEnum.Meters && !meters.length) return false

    return true
  })
}

export default useGetTerminologyFilterTypes
